import { Alert } from "@mui/material";

/**
 * "NÃO CONSEGUI LER" NÃO É "NÃO HÁ DADO".
 *
 * São respostas diferentes para quem olha, e a tela precisa saber qual é.
 * Até 04/11/2026 cada página inventava a própria frase, e duas delas vazavam
 * o slug técnico: "Eventos indisponíveis (sem_registro_de_envio)" e "Dados em
 * cache ou fora do ar (sem_registro_de_envio)" — que ainda por cima oferecia
 * duas causas diferentes como se fossem a mesma.
 *
 * A página de Logs já fazia certo: nomeava o que falta e dizia que não mostra
 * mock para não confundir com dado real. Esta função é aquele tom, num lugar
 * só.
 *
 * Motivo desconhecido não vira silêncio: vira "não consegui ler", com o
 * código ao lado para quem for investigar.
 */

const MOTIVOS: Record<string, { texto: string; grave?: boolean }> = {
  // A integração existe; o que não existe ainda é registro de envio.
  sem_registro_de_envio: {
    texto: "Nada foi enviado para este cliente ainda, então não há o que listar aqui.",
  },
  no_dataset: { texto: "Este cliente ainda não tem base publicada." },
  sem_base: { texto: "Este cliente ainda não tem base publicada." },
  audit_table_not_deployed: {
    texto: "A tabela de auditoria ainda não foi criada. Esta página popula sozinha quando ela existir.",
  },
  // Estes são falha de verdade: o dado existe e não chegou.
  kc_error: { texto: "Não consegui ler o diretório de usuários agora.", grave: true },
  kc_unavailable: { texto: "O diretório de usuários não respondeu.", grave: true },
  kc_not_configured: { texto: "O diretório de usuários não está configurado.", grave: true },
  forbidden: { texto: "Você não tem permissão para ver isto.", grave: true },
};

export function AvisoDeLeitura({ erro, oQue }: { erro?: string; oQue: string }) {
  const conhecido = erro ? MOTIVOS[erro] : undefined;
  const grave = conhecido ? conhecido.grave === true : true;
  return (
    <Alert severity={grave ? "error" : "info"} sx={{ borderRadius: 2 }}>
      {conhecido
        ? conhecido.texto
        : <>
            <strong>Não consegui ler {oQue}.</strong>{" "}
            O que aparece abaixo pode estar incompleto — isto não quer dizer que não exista.
            {erro ? ` (${erro})` : ""}
          </>}
    </Alert>
  );
}
